<template>
  <div>
    <div class="header">작업허가서</div>
    <div class="content">
      <div class="content-title">□ 기본정보</div>
      <div class="content-table">
        <table >
          <tbody>
          <tr>
            <th>현장명</th>
            <td>{{ form.stdInfo.field_name }}</td>
            <th>소속명</th>
            <td>{{ form.stdInfo.department }}</td>
            <th>부서명</th>
            <td>{{ form.stdInfo.com_name }}</td>
          </tr>
          <tr>
            <th>직책</th>
            <td>{{ form.stdInfo.rank }}</td>
            <th>작성자</th>
            <td>{{ form.stdInfo.writer_name }}</td>
            <th>작성일</th>
            <td>{{ form.stdInfo.date }}</td>
          </tr>
          <tr>
            <th>작업종류</th>
            <td colspan="5" class="check-container">
              <div class="grid grid-cols-12">
                <div v-for="item of form.inspectionList" :key="item.id" class="col-span-5" v-if="item.label !== '공통사항'">
                  <img v-if="item.check" src="@/assets/images/print/print_check_checked.svg" alt="checked" />
                  <img v-else src="@/assets/images/print/print_check_unchecked.svg" alt="unchecked" />
                  {{item.label}}
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--    장비정보-->
    <div class="content">
      <div class="content-title">□ 작업허가서 정보</div>
      <div class="content-table">
        <table >
          <tbody>
          <tr>
            <th>작업일자</th>
            <td>{{ form.inputB_1 }}</td>
            <th>협력업체명</th>
            <td>{{ form.companyName }}</td>
            <th>허가번호</th>
            <td>{{ form.inputB_3 }}</td>
          </tr>
          <tr>
            <th>관리감독자</th>
            <td>{{ form.inputB_4 }}</td>
            <th>작업내용</th>
            <td>{{ form.inputB_5 }}</td>
            <th>작업장소</th>
            <td>{{ form.inputB_6 }}</td>
          </tr>
          <tr>
            <th>주간인원</th>
            <td>{{ form.inputB_11 }}</td>
            <th>주간작업</th>
            <td colspan="3">{{ form.inputB_7 }} ~ {{ form.inputB_8 }}</td>
          </tr>
          <tr>
            <th>야간인원</th>
            <td>{{ form.inputB_12 }}</td>
            <th>야간연장<br/>(18:00 이후)</th>
            <td colspan="3">{{ form.inputB_9 }} ~ {{ form.inputB_10 }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--    사전조사 및 작업계획서 내용-->
    <div class="content">
      <div class="content-table">
        <template v-for="(table, index) of form.inspectionList" v-if="table.check">
          <div :class="index > 1 ? 'print-break-page' : 'print-break'">
            <div class="content-title">□ {{ table.label }}</div>
            <table>
              <tbody>
              <template v-for="group of table.list">
                <tr>
                  <td class="th-background">{{group.headerTitle}}</td>
                  <td class="th-background" style="width:70px;">작성</td>
                  <td class="th-background" style="width:70px;">미작성</td>
                  <td class="th-background" style="width:70px;">N/A</td>
                </tr>
                <tr v-for="(row, index) of group.list" :key="index">
                  <td class="text-left"><span v-html="row.label"></span><span v-for="(sign, signIndex) of row.sign" :key="signIndex" style="padding-left: 18px;">{{sign.name}} : {{sign.value}}</span></td>
                  <td>
                    <img v-if="row.is_checked === 'Yes'" src="@/assets/images/print/print_check_checked.svg" alt="checked" />
                    <img v-else src="@/assets/images/print/print_check_unchecked.svg" alt="unchecked" />
                  </td>
                  <td>
                    <img v-if="row.is_checked === 'No'" src="@/assets/images/print/print_check_checked.svg" alt="checked" />
                    <img v-else src="@/assets/images/print/print_check_unchecked.svg" alt="unchecked" />
                  </td>
                  <td>
                    <img v-if="row.is_checked === 'N/A'" src="@/assets/images/print/print_check_checked.svg" alt="checked" />
                    <img v-else src="@/assets/images/print/print_check_unchecked.svg" alt="unchecked" />
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print257",
  props: {
    form: Object,
    board: Object,
  },
  methods: {
    getCheckBoxUrl(checked) {
      if(checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content{
  margin-top: 20px;

  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 16px;
  }
  .content-table {
    .print-break {
      break-inside: avoid;
    }
    .print-break-page {
      page-break-before: always;
    }
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 40px;

      th, td {
        border: 1px solid #757575;
        text-align: center;
        min-height: 55px;
        height: 55px;
        font-size: 18px;
      }
      th {
        width: 140px;
        background-color: #ececec;
        font-weight: 500;
        padding: 0;
      }
      td {
        min-width: 50px;
        word-break: keep-all;
        img {
          display: inline-block;
        }
      }
      .th-background {
        background-color: #ececec;
        white-space: nowrap;
      }
      .check-container {
        padding: 10px 14px 0 14px;
        text-align: left;

        div {
          margin-bottom: 8px;
        }
        img {
          display: inline-block;
          margin-right: 8px;
        }
      }
      .text-left {
        text-align: left;
        padding: 10px 14px;
      }
    }
  }
}
</style>
